"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    QuickActions: ()=>QuickActions
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const ChatbotDataContext_js_namespaceObject = require("./context/ChatbotDataContext.js");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const analytics_js_namespaceObject = require("./analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const StandaloneStyleContext_js_namespaceObject = require("./context/StandaloneStyleContext.js");
const useChatMessagesContext_js_namespaceObject = require("./hooks/useChatMessagesContext.js");
const StyledFlex = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "QuickActions__StyledFlex"
})([
    "overflow-x:auto;",
    " ",
    " ",
    ""
], ({ isStandalone })=>isStandalone && `
      width: fit-content;
      white-space: nowrap;
      flex-wrap: wrap;
      max-width: 100%;
    `, ({ isStandalone, isSingleLine })=>isStandalone && isSingleLine && `
        position: relative;
    `, ({ isSingleLine })=>isSingleLine && `
      width: 100%;
      flex-wrap: nowrap;
      height: 91px;
    `);
const StyledButton = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Button).withConfig({
    displayName: "QuickActions__StyledButton"
})([
    "white-space:nowrap;"
]);
const QuickActions = (props)=>{
    const { submitQuickActionMessage, hasOtherMessage, quickActions, isSeparatorMsg, isSingleLine, alignItems = 'center', isStandalone, onScroll } = props;
    const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = (0, external_react_namespaceObject.useState)(true);
    const { quickActionsContainer } = (0, StandaloneStyleContext_js_namespaceObject.useStandaloneStyles)();
    const { isMobile, logFirstMessageSubmitted } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { chatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    if (!isSeparatorMsg && (!quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledFlex, {
        onScroll: onScroll,
        isStandalone: isStandalone,
        isSingleLine: isSingleLine,
        ...quickActionsContainer,
        flexDirection: "row",
        alignItems: alignItems,
        pb: 2,
        "data-testid": "quick-actions-container",
        children: quickActions.map((action, i)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                my: 2,
                mx: 1,
                alignItems: "center",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledButton, {
                    boxShadowSize: "sm",
                    variation: "white",
                    onClick: function() {
                        setQuickActionsDisplayedValue(false);
                        analytics_js_default().log({
                            label: 'quickActions',
                            message: 'QUICK_ACTION_BUTTON_CLICKED',
                            content: action.label
                        });
                        logFirstMessageSubmitted(chatMessages);
                        submitQuickActionMessage(action);
                    },
                    width: isMobile ? 1 : '',
                    children: `${action?.emoticon ?? ''} ${action.label}`
                })
            }, `quick-action-button-${i}`))
    });
};
exports.QuickActions = __webpack_exports__.QuickActions;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "QuickActions"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
